import styled from "styled-components";
import { useStyles } from "../../styles/theme";
import { hexWithOpacity } from "../../utils/hexWithOpacity";

type Props = {
  completedSteps: number;
  totalSteps: number;
  fillColor?: string;
};

export const ProgressBar = (props: Props) => {
  const theme = useStyles();
  const segments = Array.from({ length: props.totalSteps });

  return (
    <Container className="progress-bar">
      {segments.map((_, index) => {
        const fill = index < props.completedSteps ? 100 : 0;
        return (
          <Segment
            key={index}
            style={{ backgroundColor: hexWithOpacity(theme.colors.light, 0.5) }}
          >
            <Fill
              $width={fill}
              $color={props.fillColor || theme.colors.white}
            />
          </Segment>
        );
      })}
    </Container>
  );
};

const Container = styled.div`
  height: 10px;
  border-radius: 5px;
  overflow: hidden;
  width: 100%;
  display: flex;
  gap: 2px;
`;

const Segment = styled.div`
  flex: 1;
  position: relative;
  height: 100%;
`;

const Fill = styled.div<{ $width: number; $color: string }>`
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: ${({ $width }) => `${$width}%`};
  background-color: ${({ $color }) => $color};
  transition: width 0.3s ease-in-out;
`;
